module.exports = __webpack_public_path__ + "static/media/text-height.28fa0639.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icons/text-height.svg
// module id = 3658
// module chunks = 7